import { WorkflowTemplatesState } from "@idw-types/state/workflow-templates-state";
import { WorkflowTemplatesActionTypes, WorkflowTemplatesActions } from "../actions/workflow-templates-actions";

export const initialWorkflowTemplatesState: WorkflowTemplatesState = {
    data: {
        isLoading: false,
        workflowTemplates: null
    }
};

export const workflowTemplatesReducer = (
    state: WorkflowTemplatesState = initialWorkflowTemplatesState,
    action: WorkflowTemplatesActions
): WorkflowTemplatesState => {
    switch (action.type) {
        // Workflow Templates
        case WorkflowTemplatesActionTypes.SET_WORKFLOW_TEMPLATES_LOADING:
            return {
                ...state,
                data: {
                    ...(action.payload.isLoading
                        ? { ...initialWorkflowTemplatesState.data }
                        : { ...state.data }),
                    isLoading: action.payload.isLoading
                }
            };
        case WorkflowTemplatesActionTypes.SET_WORKFLOW_TEMPLATES:
            return {
                ...state,
                data: {
                    ...state.data,
                    workflowTemplates: action.payload.workflowTemplates,
                    isLoading: false
                }
            };
        case WorkflowTemplatesActionTypes.ADD_WORKFLOW_TEMPLATE:
            return {
                ...state,
                data: {
                    ...state.data,
                    workflowTemplates: state.data.workflowTemplates
                        ? [...state.data.workflowTemplates, action.payload.workflowTemplate]
                        : [action.payload.workflowTemplate]
                }
            };
        default:
            return state;
    }
};